module.exports = __webpack_public_path__ + "img/liked.1616ac4.png";